"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7224],{

/***/ 27224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54176);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48409);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77058);
/* harmony import */ var _components_atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52738);
/* harmony import */ var _components_molecules__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53732);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9465);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60651);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var CAvatar = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 19165));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(19165)];
    }
  }
});

var VenueInfoView = function VenueInfoView(props) {
  var _props$item2, _props$item2$tags, _props$item2$tags$fin, _props$item5, _props$item6, _props$item7, _props$item10, _props$item10$company, _ref, _props$item11, _props$item11$company, _props$item12, _props$item12$company, _props$item13, _props$item13$company, _rooftopFloor, _rooftopFloor$toStrin, _props$item$tag_categ, _props$item$tag_categ2, _props$item$tag_categ3, _props$item$tag_categ5, _props$item$tag_categ6, _props$item$tag_categ7, _props$item$tag_categ8, _props$item$tag_categ10, _getPrefabTagCategory, _getPrefabTagCategory2, _getPrefabTagCategory3, _getPrefabTagCategory4, _getPrefabTagCategory5, _getPrefabTagCategory6, _getPrefabTagCategory10, _getPrefabTagCategory11, _props$item$tag_categ11, _props$item$tag_categ12, _props$item$tag_categ13, _props$item$tag_categ15, _props$item$tag_categ16, _props$item$tag_categ17, _props$item$tag_categ18, _props$item$tag_categ20, _props$item14, _props$item15, _props$item16, _props$item17, _props$item18, _props$item18$company, _ref2, _props$item19, _props$item19$company, _props$item20, _props$item20$company, _props$item21, _props$item21$company, _rooftopFloor2, _rooftopFloor2$toStri, _prefabHomeCategory, _prefabHomeCategory$f, _prefabHomeCategory2, _prefabHomeCategory4, _props$item$tag_categ21, _props$item$tag_categ22, _props$item$tag_categ23, _props$item$tag_categ25, _getPrefabTagCategory12, _getPrefabTagCategory13, _getPrefabTagCategory14, _getPrefabTagCategory15, _getPrefabTagCategory16, _getPrefabTagCategory17, _getPrefabTagCategory21, _getPrefabTagCategory22, _props$item$tag_categ26, _props$item$tag_categ27, _props$item$tag_categ28, _props$item$tag_categ30, _props$item$tag_categ31, _props$item$tag_categ32, _props$item$tag_categ33, _props$item$tag_categ35, _props$item22, _props$item23, _props$item24, _props$item25;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var category = props.category,
      isMobileVersion = props.isMobileVersion;
  var alertModalGenreRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var alertModalFeatureRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var alertModalCategoryRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var alertModalLocationRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showPopupOfficial = _useState[0],
      setShowPopupOfficial = _useState[1];

  var _props$item = props.item,
      id = _props$item.id,
      isFollow = _props$item.isFollow,
      profileId = _props$item.profileId,
      isVirtual = _props$item.isVirtual,
      isInPerson = _props$item.isInPerson,
      title = _props$item.title,
      location = _props$item.location,
      startDate = _props$item.startDate,
      periodString = _props$item.periodString,
      totalFollower = _props$item.totalFollower,
      totalFollowing = _props$item.totalFollowing,
      totalConnection = _props$item.totalConnection,
      logo = _props$item.logo,
      nickname = _props$item.nickname,
      username = _props$item.username,
      rating = _props$item.rating,
      userType = _props$item.userType,
      activity = _props$item.activity,
      bio = _props$item.bio,
      city = _props$item.city,
      nationality = _props$item.nationality,
      genres = _props$item.genres,
      isOfficial = _props$item.isOfficial,
      isPro = _props$item.isPro,
      tag_venue_2 = _props$item.tag_venue_2;
  var genreItems = [];

  if (genres) {
    genreItems = genres;
  }

  var userTypeName = "-";
  var rooftopFloor = "-";
  var rooftopView = "-";
  var tagChildren = (_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : (_props$item2$tags = _props$item2.tags) === null || _props$item2$tags === void 0 ? void 0 : (_props$item2$tags$fin = _props$item2$tags.find(function (i) {
    var _i$children;

    return i === null || i === void 0 ? void 0 : (_i$children = i.children) === null || _i$children === void 0 ? void 0 : _i$children.find(function (j) {
      return j.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VENUE */ .gT.tagCategory.TAG_CATEGORY_VENUE || j.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_FLOOR */ .gT.tagCategory.TAG_CATEGORY_FLOOR || j.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VIEW */ .gT.tagCategory.TAG_CATEGORY_VIEW;
    });
  })) === null || _props$item2$tags$fin === void 0 ? void 0 : _props$item2$tags$fin.children;

  for (var i = 0; i < (tagChildren === null || tagChildren === void 0 ? void 0 : tagChildren.length); i++) {
    var _tagChildren$i, _tagChildren$i3, _tagChildren$i5;

    if (((_tagChildren$i = tagChildren[i]) === null || _tagChildren$i === void 0 ? void 0 : _tagChildren$i.category) === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VENUE */ .gT.tagCategory.TAG_CATEGORY_VENUE) {
      var _tagChildren$i2, _tagChildren$i2$child;

      userTypeName = (_tagChildren$i2 = tagChildren[i]) === null || _tagChildren$i2 === void 0 ? void 0 : (_tagChildren$i2$child = _tagChildren$i2.children[0]) === null || _tagChildren$i2$child === void 0 ? void 0 : _tagChildren$i2$child.name;
    }

    if (((_tagChildren$i3 = tagChildren[i]) === null || _tagChildren$i3 === void 0 ? void 0 : _tagChildren$i3.category) === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_FLOOR */ .gT.tagCategory.TAG_CATEGORY_FLOOR) {
      var _tagChildren$i4, _tagChildren$i4$child;

      rooftopFloor = (_tagChildren$i4 = tagChildren[i]) === null || _tagChildren$i4 === void 0 ? void 0 : (_tagChildren$i4$child = _tagChildren$i4.children[0]) === null || _tagChildren$i4$child === void 0 ? void 0 : _tagChildren$i4$child.maxValue;
    }

    if (((_tagChildren$i5 = tagChildren[i]) === null || _tagChildren$i5 === void 0 ? void 0 : _tagChildren$i5.category) === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VIEW */ .gT.tagCategory.TAG_CATEGORY_VIEW) {
      var _tagChildren$i6, _tagChildren$i6$child;

      rooftopView = (_tagChildren$i6 = tagChildren[i]) === null || _tagChildren$i6 === void 0 ? void 0 : (_tagChildren$i6$child = _tagChildren$i6.children[0]) === null || _tagChildren$i6$child === void 0 ? void 0 : _tagChildren$i6$child.name;
    }
  }

  var genreName = genreItems.length > 0 ? genreItems[0].title : null;
  var moreGenre = genreItems.length > 1 ? "+" + (genreItems.length - 1) : null;
  var fullGenreNames = genreItems.map(function (genreItem) {
    return genreItem.title;
  }).join(", ");

  var prefabHomeCategory = function prefabHomeCategory() {
    var _props$item3;

    var prefabHomeCategories = [];
    var resultTags = [];
    (_props$item3 = props.item) === null || _props$item3 === void 0 ? void 0 : _props$item3.tags.forEach(function (item, index) {
      var _props$item4, _tagGroup$children;

      var tagGroup = (_props$item4 = props.item) === null || _props$item4 === void 0 ? void 0 : _props$item4.tags[index];

      var _tagCategories = (tagGroup === null || tagGroup === void 0 ? void 0 : (_tagGroup$children = tagGroup.children) === null || _tagGroup$children === void 0 ? void 0 : _tagGroup$children.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_FLOOR */ .gT.tagCategory.TAG_CATEGORY_FLOOR && i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VIEW */ .gT.tagCategory.TAG_CATEGORY_VIEW;
      })) || [];

      resultTags = resultTags.concat(_tagCategories);
    });
    resultTags.filter(function (i) {
      return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY */ .gT.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY;
    }).map(function (item) {
      prefabHomeCategories.push(item.children[0]);
    });
    return (0,lodash__WEBPACK_IMPORTED_MODULE_9__.uniqBy)(prefabHomeCategories.map(function (i) {
      return i.title;
    }));
  };

  var venueStatus = ((_props$item5 = props.item) === null || _props$item5 === void 0 ? void 0 : _props$item5.venueStatus) === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_OPEN */ .gT.venueStatus.FE_STAT_OPEN ? "Open" : ((_props$item6 = props.item) === null || _props$item6 === void 0 ? void 0 : _props$item6.venueStatus) === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_CLOSE */ .gT.venueStatus.FE_STAT_CLOSE ? "Closed" : ((_props$item7 = props.item) === null || _props$item7 === void 0 ? void 0 : _props$item7.venueStatus) === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.venueStatus.FE_STAT_PERMANENTLY_CLOSED */ .gT.venueStatus.FE_STAT_PERMANENTLY_CLOSED ? "Permanently Closed" : "Temporarily Closed";
  var venueTypeTexts = category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE ? [userTypeName, venueStatus] : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? [] : [venueStatus];
  var hasNationality = nationality != null && nationality != "";
  var profileStatusItems = [{
    value: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .formatNumber */ .uf)(totalFollower || 0),
    label: t("key_profile_status_followers"),
    type: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.profileStatusType.PROFILE_STATUS_FOLLOWER */ .gT.profileStatusType.PROFILE_STATUS_FOLLOWER
  }, {
    value: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .formatNumber */ .uf)(totalFollowing || 0),
    label: t("key_profile_status_followings"),
    type: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.profileStatusType.PROFILE_STATUS_FOLLOWING */ .gT.profileStatusType.PROFILE_STATUS_FOLLOWING
  }, {
    value: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .formatNumber */ .uf)(totalConnection || 0),
    label: t("key_profile_status_connections"),
    type: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.profileStatusType.PROFILE_STATUS_CONNECTION */ .gT.profileStatusType.PROFILE_STATUS_CONNECTION
  }];

  var getPrefabTagCategory = function getPrefabTagCategory() {
    var _props$item8;

    var result = [];
    (_props$item8 = props.item) === null || _props$item8 === void 0 ? void 0 : _props$item8.tags.forEach(function (item, index) {
      var _props$item9, _tagGroup$children2;

      var tagGroup = (_props$item9 = props.item) === null || _props$item9 === void 0 ? void 0 : _props$item9.tags[index];

      var _tagCategories = (tagGroup === null || tagGroup === void 0 ? void 0 : (_tagGroup$children2 = tagGroup.children) === null || _tagGroup$children2 === void 0 ? void 0 : _tagGroup$children2.filter(function (i) {
        return i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_FLOOR */ .gT.tagCategory.TAG_CATEGORY_FLOOR && i.category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_VIEW */ .gT.tagCategory.TAG_CATEGORY_VIEW;
      })) || [];

      result = result.concat(_tagCategories);
    });
    return concatChildrenById(result.filter(function (i) {
      return i.category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY */ .gT.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY;
    })).map(function (i) {
      return _objectSpread(_objectSpread({}, i), {}, {
        children: (0,lodash__WEBPACK_IMPORTED_MODULE_9__.uniqBy)(i.children, "id")
      });
    })[0];
  }; // Function to concatenate children by id


  function concatChildrenById(arr) {
    var result = [];
    var idMap = {};
    arr.forEach(function (item) {
      var id = item.id;

      if (!idMap[id]) {
        // Initialize a copy of the item with an empty children array
        var copy = _objectSpread({}, item);

        copy.children = [];
        result.push(copy);
        idMap[id] = copy;
      } // Concatenate the children


      idMap[id].children = idMap[id].children.concat(item.children);
    });
    return result;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
    style: [styles.container, props.style],
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
      style: isMobileVersion ? {} : {
        alignSelf: "center",
        maxWidth: _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.PROFILE_PAGE_WIDTH */ .gT.PROFILE_PAGE_WIDTH,
        width: "100%"
      },
      children: [isMobileVersion ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
          style: styles.userInfoContainer,
          children: [category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT && category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(CAvatar, {
            url: (props === null || props === void 0 ? void 0 : (_props$item10 = props.item) === null || _props$item10 === void 0 ? void 0 : (_props$item10$company = _props$item10.company) === null || _props$item10$company === void 0 ? void 0 : _props$item10$company.logo) || logo || (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL ? "Local:defaultGeneral" : "Local:defaultVenue"),
            size: 70,
            alt: "".concat(nickname, " ").concat(category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST ? "Artist" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE ? "Venue" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP ? "Rooftop" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA ? "Spa" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL ? "Beach Club" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY ? "Company" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? "Home" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO ? "Zoo/animal park" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL ? "Animal" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL ? "Park" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO ? "Casino" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? "Castle" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT ? "Resort" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL ? "Aparthotel" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "Bar" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT ? "Event" : "Festival", " Logo")
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.nameContainer, isMobileVersion ? {
              alignItems: "flex-start",
              marginLeft: 16
            } : {}],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
              style: {
                flexDirection: "row",
                marginTop: 4,
                paddingRight: 40
              },
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: [styles.nickname, isMobileVersion ? {
                  fontSize: 16,
                  lineHeight: 19.5,
                  textAlign: "left"
                } : {}],
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h1", {
                  children: nickname
                })
              }), (isOfficial || isPro) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
                onMouseOver: function onMouseOver() {
                  return setShowPopupOfficial(true);
                },
                onMouseLeave: function onMouseLeave() {
                  return setShowPopupOfficial(false);
                },
                style: {
                  marginLeft: 6,
                  marginTop: -2,
                  position: "relative"
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
                  source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconVerifiedBadge */ .rU.iconVerifiedBadge,
                  alt: "badge official",
                  width: 14,
                  height: 14,
                  layout: "fixed"
                }), showPopupOfficial && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
                  style: {
                    position: "absolute",
                    width: isMobileVersion ? 260 : 336,
                    height: isMobileVersion ? 140 + 24 : 182 + 24,
                    zIndex: 999,
                    left: -(_config__WEBPACK_IMPORTED_MODULE_2__/* .Values.deviceWidth */ .$m.deviceWidth / 2),
                    top: 0,
                    paddingTop: 24
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
                    style: (_ref = {
                      backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getClass */ .ll)("bg-gray1"),
                      width: isMobileVersion ? 260 : 336,
                      height: isMobileVersion ? 140 : 182,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingHorizontal: 22,
                      borderRadius: 18
                    }, (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, "width", "100%"), (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, "height", "100%"), (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, "boxShadow", "2px 2px 10px rgba(0,0,0,0.5)"), _ref),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
                      source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconVerifiedBadgeMedium */ .rU.iconVerifiedBadgeMedium,
                      alt: "verified account",
                      width: isMobileVersion ? 24 : 35,
                      height: isMobileVersion ? 24 : 35,
                      layout: "fixed"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                      style: {
                        fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryBold */ .F3.primaryBold,
                        fontSize: isMobileVersion ? 16 : 20,
                        lineHeight: isMobileVersion ? 20 : 24,
                        color: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.white */ .wL.white,
                        marginVertical: isMobileVersion ? 9 : 14,
                        textAlign: "center"
                      },
                      children: "Official Account"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                      style: {
                        fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryRegular */ .F3.primaryRegular,
                        fontSize: isMobileVersion ? 12 : 16,
                        lineHeight: isMobileVersion ? 16 : 18,
                        color: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.white80 */ .wL.white80,
                        textAlign: "center"
                      },
                      children: ["This is an official account verified by", " ", "Cocktayl"]
                    })]
                  })
                })]
              })]
            }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
              href: (0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .generateURLSlug */ .ZF)(props === null || props === void 0 ? void 0 : (_props$item11 = props.item) === null || _props$item11 === void 0 ? void 0 : (_props$item11$company = _props$item11.company) === null || _props$item11$company === void 0 ? void 0 : _props$item11$company.id, props === null || props === void 0 ? void 0 : (_props$item12 = props.item) === null || _props$item12 === void 0 ? void 0 : (_props$item12$company = _props$item12.company) === null || _props$item12$company === void 0 ? void 0 : _props$item12$company.nickname, null, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY, "about"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                  style: [styles.username, {
                    marginTop: 4,
                    textDecorationLine: "underline"
                  }, isMobileVersion ? {
                    fontSize: 10,
                    lineHeight: 18
                  } : {}],
                  children: (_props$item13 = props.item) === null || _props$item13 === void 0 ? void 0 : (_props$item13$company = _props$item13.company) === null || _props$item13$company === void 0 ? void 0 : _props$item13$company.nickname
                })
              })
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.username, {
                marginTop: 4
              }, isMobileVersion ? {
                fontSize: 10,
                lineHeight: 18
              } : {}],
              children: ["@", username]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
              style: [styles.rowContainer, {
                alignItems: "center",
                marginTop: 4
              }],
              children: [category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
                style: {
                  width: 18,
                  height: 18,
                  marginRight: 2
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
                  source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconSearchVenue */ .rU.iconSearchVenue,
                  style: styles.icon,
                  height: 14,
                  width: 14,
                  layout: "fixed",
                  resizeMode: "contain"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .DotSplitedText */ .cf, {
                texts: venueTypeTexts,
                textStyle: {
                  color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getClass */ .ll)("text-white"),
                  lineHeight: 20,
                  fontSize: 12,
                  fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryRegular */ .F3.primaryRegular
                },
                dotStyle: {
                  backgroundColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.white */ .wL.white
                },
                style: {
                  marginLeft: category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE ? 4 : 0
                },
                isSecondOpacity: true
              })]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
          style: styles.bioMobile,
          children: bio === null || bio === void 0 ? void 0 : bio.substring(0, 30)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
          style: [styles.rowContainer, {
            marginTop: 10,
            marginHorizontal: 16,
            justifyContent: "space-between"
          }],
          children: [category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: styles.rowContainer,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
              style: {
                width: 14,
                height: 14,
                marginRight: 4
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
                source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagMusic */ .rU.iconTagMusic,
                width: 14,
                height: 14
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: genreName
            }), moreGenre && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 22,
                borderRadius: 11,
                marginLeft: 4,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                alertModalGenreRef.current.alert("Music", fullGenreNames);
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: [styles.boldText, isMobileVersion ? {
                  fontSize: 10,
                  lineHeight: 12
                } : {}],
                children: moreGenre
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 14,
              height: 14,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagView */ .rU.iconTagView,
              style: [styles.locationPin]
            }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: "".concat(rooftopFloor === "-" ? "-" : (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .nthNumber */ ._Z)((_rooftopFloor = rooftopFloor) === null || _rooftopFloor === void 0 ? void 0 : (_rooftopFloor$toStrin = _rooftopFloor.toString()) === null || _rooftopFloor$toStrin === void 0 ? void 0 : _rooftopFloor$toStrin.split(".")[0]) + " Floor", "  |  ").concat(rooftopView === "-" ? "-" : rooftopView + "°")
            })]
          }), (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 14,
              height: 14,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagGeneral */ .rU.iconTagGeneral,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: tag_venue_2
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 14,
              height: 14,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagFeature */ .rU.iconTagFeature,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: (_props$item$tag_categ = props.item.tag_category) === null || _props$item$tag_categ === void 0 ? void 0 : (_props$item$tag_categ2 = _props$item$tag_categ.filter(function (i, index) {
                return index <= 1;
              })) === null || _props$item$tag_categ2 === void 0 ? void 0 : _props$item$tag_categ2.join(", ")
            }), ((_props$item$tag_categ3 = props.item.tag_category) === null || _props$item$tag_categ3 === void 0 ? void 0 : _props$item$tag_categ3.length) > 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                var _props$item$tag_categ4;

                alertModalFeatureRef.current.alert("Category", (_props$item$tag_categ4 = props.item.tag_category) === null || _props$item$tag_categ4 === void 0 ? void 0 : _props$item$tag_categ4.join(", "));
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: [styles.boldText, isMobileVersion ? {
                  fontSize: 10,
                  lineHeight: 12
                } : {}],
                children: "+" + (((_props$item$tag_categ5 = props.item.tag_category) === null || _props$item$tag_categ5 === void 0 ? void 0 : _props$item$tag_categ5.length) - 2)
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 14,
              height: 14,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagStatus */ .rU.iconTagStatus,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: (_props$item$tag_categ6 = props.item.tag_category) === null || _props$item$tag_categ6 === void 0 ? void 0 : (_props$item$tag_categ7 = _props$item$tag_categ6.filter(function (i, index) {
                return index <= 1;
              })) === null || _props$item$tag_categ7 === void 0 ? void 0 : _props$item$tag_categ7.join(", ")
            }), ((_props$item$tag_categ8 = props.item.tag_category) === null || _props$item$tag_categ8 === void 0 ? void 0 : _props$item$tag_categ8.length) > 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                var _props$item$tag_categ9;

                alertModalFeatureRef.current.alert("Category", (_props$item$tag_categ9 = props.item.tag_category) === null || _props$item$tag_categ9 === void 0 ? void 0 : _props$item$tag_categ9.join(", "));
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: [styles.boldText, isMobileVersion ? {
                  fontSize: 10,
                  lineHeight: 12
                } : {}],
                children: "+" + (((_props$item$tag_categ10 = props.item.tag_category) === null || _props$item$tag_categ10 === void 0 ? void 0 : _props$item$tag_categ10.length) - 2)
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 14,
              height: 14,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagFeature */ .rU.iconTagFeature,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: (_getPrefabTagCategory = getPrefabTagCategory()) === null || _getPrefabTagCategory === void 0 ? void 0 : (_getPrefabTagCategory2 = _getPrefabTagCategory.children) === null || _getPrefabTagCategory2 === void 0 ? void 0 : (_getPrefabTagCategory3 = _getPrefabTagCategory2.filter(function (i, index) {
                return index <= 1;
              })) === null || _getPrefabTagCategory3 === void 0 ? void 0 : (_getPrefabTagCategory4 = _getPrefabTagCategory3.map(function (i) {
                return i.name;
              })) === null || _getPrefabTagCategory4 === void 0 ? void 0 : _getPrefabTagCategory4.join(", ")
            }), ((_getPrefabTagCategory5 = getPrefabTagCategory()) === null || _getPrefabTagCategory5 === void 0 ? void 0 : (_getPrefabTagCategory6 = _getPrefabTagCategory5.children) === null || _getPrefabTagCategory6 === void 0 ? void 0 : _getPrefabTagCategory6.length) > 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                var _getPrefabTagCategory7, _getPrefabTagCategory8, _getPrefabTagCategory9;

                alertModalFeatureRef.current.alert("Category", (_getPrefabTagCategory7 = getPrefabTagCategory()) === null || _getPrefabTagCategory7 === void 0 ? void 0 : (_getPrefabTagCategory8 = _getPrefabTagCategory7.children) === null || _getPrefabTagCategory8 === void 0 ? void 0 : (_getPrefabTagCategory9 = _getPrefabTagCategory8.map(function (i) {
                  return i.name;
                })) === null || _getPrefabTagCategory9 === void 0 ? void 0 : _getPrefabTagCategory9.join(", "));
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: [styles.boldText, isMobileVersion ? {
                  fontSize: 10,
                  lineHeight: 12
                } : {}],
                children: "+" + (((_getPrefabTagCategory10 = getPrefabTagCategory()) === null || _getPrefabTagCategory10 === void 0 ? void 0 : (_getPrefabTagCategory11 = _getPrefabTagCategory10.children) === null || _getPrefabTagCategory11 === void 0 ? void 0 : _getPrefabTagCategory11.length) - 2)
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 14,
              height: 14,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagFeature */ .rU.iconTagFeature,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: (_props$item$tag_categ11 = props.item.tag_category) === null || _props$item$tag_categ11 === void 0 ? void 0 : (_props$item$tag_categ12 = _props$item$tag_categ11.filter(function (i, index) {
                return index <= 1;
              })) === null || _props$item$tag_categ12 === void 0 ? void 0 : _props$item$tag_categ12.join(", ")
            }), ((_props$item$tag_categ13 = props.item.tag_category) === null || _props$item$tag_categ13 === void 0 ? void 0 : _props$item$tag_categ13.length) > 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                var _props$item$tag_categ14;

                alertModalFeatureRef.current.alert("Features", (_props$item$tag_categ14 = props.item.tag_category) === null || _props$item$tag_categ14 === void 0 ? void 0 : _props$item$tag_categ14.join(", "));
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: [styles.boldText, isMobileVersion ? {
                  fontSize: 10,
                  lineHeight: 12
                } : {}],
                children: "+" + (((_props$item$tag_categ15 = props.item.tag_category) === null || _props$item$tag_categ15 === void 0 ? void 0 : _props$item$tag_categ15.length) - 2)
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 14,
              height: 14,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagFeature */ .rU.iconTagFeature,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: (_props$item$tag_categ16 = props.item.tag_category) === null || _props$item$tag_categ16 === void 0 ? void 0 : (_props$item$tag_categ17 = _props$item$tag_categ16.filter(function (i, index) {
                return index <= 1;
              })) === null || _props$item$tag_categ17 === void 0 ? void 0 : _props$item$tag_categ17.join(", ")
            }), ((_props$item$tag_categ18 = props.item.tag_category) === null || _props$item$tag_categ18 === void 0 ? void 0 : _props$item$tag_categ18.length) > 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                var _props$item$tag_categ19;

                alertModalFeatureRef.current.alert("Category", (_props$item$tag_categ19 = props.item.tag_category) === null || _props$item$tag_categ19 === void 0 ? void 0 : _props$item$tag_categ19.join(", "));
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: [styles.boldText, isMobileVersion ? {
                  fontSize: 10,
                  lineHeight: 12
                } : {}],
                children: "+" + (((_props$item$tag_categ20 = props.item.tag_category) === null || _props$item$tag_categ20 === void 0 ? void 0 : _props$item$tag_categ20.length) - 2)
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
            style: [styles.rowContainer],
            onPress: function onPress() {
              alertModalCategoryRef.current.alert("Category", props.item.tag_category);
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 14,
              height: 14,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagEventType */ .rU.iconTagEventType,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: props.item.tag_category
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: styles.rowContainer,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: ["Built in ", props.item.founding, " ", props.item.founding_unit]
            })
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 14,
              height: 14,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagArea */ .rU.iconTagArea,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: props.item.tag_area
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 14,
              height: 14,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagEventType */ .rU.iconTagEventType,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: props.item.tag_category
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: [(_props$item14 = props.item) !== null && _props$item14 !== void 0 && _props$item14.tag_price ? "From ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .formatCurrency */ .xG)((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .formatNumber */ .uf)((_props$item15 = props.item) === null || _props$item15 === void 0 ? void 0 : _props$item15.tag_price))) : "", (_props$item16 = props.item) !== null && _props$item16 !== void 0 && _props$item16.tag_price ? " | " : "", "Min ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .formatNumber */ .uf)((_props$item17 = props.item) === null || _props$item17 === void 0 ? void 0 : _props$item17.tag_size), " sqft")]
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
            children: category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL ? null : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: styles.rowContainer,
              onPress: function onPress() {
                return nationality !== "" && nationality !== null ? alertModalLocationRef.current.alert("Location", // `${city}, ${nationality}`
                category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY ? "".concat(nationality) : "".concat(city)) : null;
              },
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
                style: {
                  width: 14,
                  height: 14,
                  marginRight: 4
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
                  source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconLocationPin */ .rU.iconLocationPin,
                  width: 12,
                  height: 12
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: [styles.text, isMobileVersion ? {
                  fontSize: 12,
                  lineHeight: 20
                } : {}],
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("address", {
                  style: {
                    fontStyle: "normal"
                  },
                  children: category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY ? "".concat(nationality) : "".concat(city)
                })
              })]
            })
          })]
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
        children: [category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT && category !== _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(CAvatar, {
          url: (props === null || props === void 0 ? void 0 : (_props$item18 = props.item) === null || _props$item18 === void 0 ? void 0 : (_props$item18$company = _props$item18.company) === null || _props$item18$company === void 0 ? void 0 : _props$item18$company.logo) || logo || (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL ? "Local:defaultGeneral" : "Local:defaultVenue"),
          size: 130,
          style: {
            alignSelf: "center",
            marginTop: -65
          },
          alt: "".concat(nickname, " ").concat(category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST ? "Artist" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE ? "Venue" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP ? "Rooftop" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA ? "Spa" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL ? "Beach Club" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY ? "Company" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? "Home" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO ? "Zoo/animal park" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL ? "Animal" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL ? "Park" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO ? "Casino" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "Bar" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT ? "Event" : "Festival", " Logo")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
          style: {
            alignSelf: "center"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: styles.nameContainer,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
              style: {
                flexDirection: "row",
                marginTop: 25,
                alignItems: "center"
              },
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: styles.nickname,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h1", {
                  children: nickname
                })
              }), (isOfficial || isPro) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
                onMouseOver: function onMouseOver() {
                  return setShowPopupOfficial(true);
                },
                onMouseLeave: function onMouseLeave() {
                  return setShowPopupOfficial(false);
                },
                style: {
                  marginLeft: 8,
                  marginTop: -16,
                  position: "relative"
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
                  source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconVerifiedBadge */ .rU.iconVerifiedBadge,
                  alt: "badge official",
                  width: 14,
                  height: 14,
                  layout: "fixed"
                }), showPopupOfficial && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
                  style: {
                    position: "absolute",
                    width: isMobileVersion ? 260 + 24 : 336 + 24,
                    height: isMobileVersion ? 140 : 182,
                    zIndex: 10,
                    left: 0,
                    top: -91,
                    paddingLeft: 24
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
                    style: (_ref2 = {
                      backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getClass */ .ll)("bg-gray1"),
                      width: isMobileVersion ? 260 : 336,
                      height: isMobileVersion ? 140 : 182,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingHorizontal: 22,
                      borderRadius: 18
                    }, (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, "width", "100%"), (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, "height", "100%"), (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, "boxShadow", "2px 2px 10px rgba(0,0,0,0.5)"), _ref2),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
                      source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconVerifiedBadgeMedium */ .rU.iconVerifiedBadgeMedium,
                      alt: "verified account",
                      width: isMobileVersion ? 24 : 35,
                      height: isMobileVersion ? 24 : 35,
                      layout: "fixed"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                      style: {
                        fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryBold */ .F3.primaryBold,
                        fontSize: isMobileVersion ? 16 : 20,
                        lineHeight: isMobileVersion ? 20 : 24,
                        color: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.white */ .wL.white,
                        marginVertical: isMobileVersion ? 9 : 14,
                        textAlign: "center"
                      },
                      children: "Official Account"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                      style: {
                        fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryRegular */ .F3.primaryRegular,
                        fontSize: isMobileVersion ? 12 : 16,
                        lineHeight: isMobileVersion ? 16 : 18,
                        color: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.white80 */ .wL.white80,
                        textAlign: "center"
                      },
                      children: ["This is an official account verified by", " ", "Cocktayl"]
                    })]
                  })
                })]
              })]
            }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
              href: (0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .generateURLSlug */ .ZF)(props === null || props === void 0 ? void 0 : (_props$item19 = props.item) === null || _props$item19 === void 0 ? void 0 : (_props$item19$company = _props$item19.company) === null || _props$item19$company === void 0 ? void 0 : _props$item19$company.id, props === null || props === void 0 ? void 0 : (_props$item20 = props.item) === null || _props$item20 === void 0 ? void 0 : (_props$item20$company = _props$item20.company) === null || _props$item20$company === void 0 ? void 0 : _props$item20$company.nickname, null, _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY, "about"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                  style: [styles.username, {
                    marginTop: 13,
                    textDecorationLine: "underline"
                  }],
                  children: (_props$item21 = props.item) === null || _props$item21 === void 0 ? void 0 : (_props$item21$company = _props$item21.company) === null || _props$item21$company === void 0 ? void 0 : _props$item21$company.nickname
                })
              })
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.username, {
                marginTop: 13
              }],
              children: ["@", username]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
              style: [styles.rowContainer, {
                alignItems: "center",
                marginTop: 15
              }],
              children: [category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
                source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconSearchVenue */ .rU.iconSearchVenue,
                style: styles.icon,
                height: 20,
                width: 20,
                layout: "fixed",
                resizeMode: "contain"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .DotSplitedText */ .cf, {
                texts: venueTypeTexts,
                textStyle: {
                  color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getClass */ .ll)("text-white"),
                  lineHeight: 20,
                  fontSize: 16,
                  fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryRegular */ .F3.primaryRegular
                },
                dotStyle: {
                  backgroundColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.white */ .wL.white,
                  width: 3,
                  height: 3,
                  borderRadius: 3
                },
                style: {
                  marginLeft: category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE ? 10 : 0
                },
                isSecondOpacity: true
              })]
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
          style: [styles.rowContainer, {
            marginTop: 34,
            marginHorizontal: 16,
            justifyContent: "space-between",
            alignItems: "flex-end"
          }],
          children: [category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagMusic */ .rU.iconTagMusic,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: genreName
            }), moreGenre && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                alertModalGenreRef.current.alert("Music", fullGenreNames);
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: styles.boldText,
                children: moreGenre
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagView */ .rU.iconTagView,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: "".concat(rooftopFloor === "-" ? "-" : (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .nthNumber */ ._Z)((_rooftopFloor2 = rooftopFloor) === null || _rooftopFloor2 === void 0 ? void 0 : (_rooftopFloor2$toStri = _rooftopFloor2.toString()) === null || _rooftopFloor2$toStri === void 0 ? void 0 : _rooftopFloor2$toStri.split(".")[0]) + " Floor", "  |  ").concat(rooftopView === "-" ? "-" : rooftopView + "°")
            })]
          }), (category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA || category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagGeneral */ .rU.iconTagGeneral,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: tag_venue_2
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagFeature */ .rU.iconTagFeature,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: (_prefabHomeCategory = prefabHomeCategory()) === null || _prefabHomeCategory === void 0 ? void 0 : (_prefabHomeCategory$f = _prefabHomeCategory.filter(function (i, index) {
                return index <= 1;
              })) === null || _prefabHomeCategory$f === void 0 ? void 0 : _prefabHomeCategory$f.join(", ")
            }), ((_prefabHomeCategory2 = prefabHomeCategory()) === null || _prefabHomeCategory2 === void 0 ? void 0 : _prefabHomeCategory2.length) > 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                var _prefabHomeCategory3;

                alertModalFeatureRef.current.alert("Category", (_prefabHomeCategory3 = prefabHomeCategory()) === null || _prefabHomeCategory3 === void 0 ? void 0 : _prefabHomeCategory3.join(", "));
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: styles.boldText,
                children: "+" + (((_prefabHomeCategory4 = prefabHomeCategory()) === null || _prefabHomeCategory4 === void 0 ? void 0 : _prefabHomeCategory4.length) - 2)
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagFeature */ .rU.iconTagFeature,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: (_props$item$tag_categ21 = props.item.tag_category) === null || _props$item$tag_categ21 === void 0 ? void 0 : (_props$item$tag_categ22 = _props$item$tag_categ21.filter(function (i, index) {
                return index <= 1;
              })) === null || _props$item$tag_categ22 === void 0 ? void 0 : _props$item$tag_categ22.join(", ")
            }), ((_props$item$tag_categ23 = props.item.tag_category) === null || _props$item$tag_categ23 === void 0 ? void 0 : _props$item$tag_categ23.length) > 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                var _props$item$tag_categ24;

                alertModalFeatureRef.current.alert("Category", (_props$item$tag_categ24 = props.item.tag_category) === null || _props$item$tag_categ24 === void 0 ? void 0 : _props$item$tag_categ24.join(", "));
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: styles.boldText,
                children: "+" + (((_props$item$tag_categ25 = props.item.tag_category) === null || _props$item$tag_categ25 === void 0 ? void 0 : _props$item$tag_categ25.length) - 2)
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagFeature */ .rU.iconTagFeature,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: (_getPrefabTagCategory12 = getPrefabTagCategory()) === null || _getPrefabTagCategory12 === void 0 ? void 0 : (_getPrefabTagCategory13 = _getPrefabTagCategory12.children) === null || _getPrefabTagCategory13 === void 0 ? void 0 : (_getPrefabTagCategory14 = _getPrefabTagCategory13.filter(function (i, index) {
                return index <= 1;
              })) === null || _getPrefabTagCategory14 === void 0 ? void 0 : (_getPrefabTagCategory15 = _getPrefabTagCategory14.map(function (i) {
                return i.name;
              })) === null || _getPrefabTagCategory15 === void 0 ? void 0 : _getPrefabTagCategory15.join(", ")
            }), ((_getPrefabTagCategory16 = getPrefabTagCategory()) === null || _getPrefabTagCategory16 === void 0 ? void 0 : (_getPrefabTagCategory17 = _getPrefabTagCategory16.children) === null || _getPrefabTagCategory17 === void 0 ? void 0 : _getPrefabTagCategory17.length) > 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                var _getPrefabTagCategory18, _getPrefabTagCategory19, _getPrefabTagCategory20;

                alertModalFeatureRef.current.alert("Category", (_getPrefabTagCategory18 = getPrefabTagCategory()) === null || _getPrefabTagCategory18 === void 0 ? void 0 : (_getPrefabTagCategory19 = _getPrefabTagCategory18.children) === null || _getPrefabTagCategory19 === void 0 ? void 0 : (_getPrefabTagCategory20 = _getPrefabTagCategory19.map(function (i) {
                  return i.name;
                })) === null || _getPrefabTagCategory20 === void 0 ? void 0 : _getPrefabTagCategory20.join(", "));
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: styles.boldText,
                children: "+" + (((_getPrefabTagCategory21 = getPrefabTagCategory()) === null || _getPrefabTagCategory21 === void 0 ? void 0 : (_getPrefabTagCategory22 = _getPrefabTagCategory21.children) === null || _getPrefabTagCategory22 === void 0 ? void 0 : _getPrefabTagCategory22.length) - 2)
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagFeature */ .rU.iconTagFeature,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: (_props$item$tag_categ26 = props.item.tag_category) === null || _props$item$tag_categ26 === void 0 ? void 0 : (_props$item$tag_categ27 = _props$item$tag_categ26.filter(function (i, index) {
                return index <= 1;
              })) === null || _props$item$tag_categ27 === void 0 ? void 0 : _props$item$tag_categ27.join(", ")
            }), ((_props$item$tag_categ28 = props.item.tag_category) === null || _props$item$tag_categ28 === void 0 ? void 0 : _props$item$tag_categ28.length) > 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                var _props$item$tag_categ29;

                alertModalFeatureRef.current.alert("Features", (_props$item$tag_categ29 = props.item.tag_category) === null || _props$item$tag_categ29 === void 0 ? void 0 : _props$item$tag_categ29.join(", "));
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: styles.boldText,
                children: "+" + (((_props$item$tag_categ30 = props.item.tag_category) === null || _props$item$tag_categ30 === void 0 ? void 0 : _props$item$tag_categ30.length) - 2)
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagFeature */ .rU.iconTagFeature,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: (_props$item$tag_categ31 = props.item.tag_category) === null || _props$item$tag_categ31 === void 0 ? void 0 : (_props$item$tag_categ32 = _props$item$tag_categ31.filter(function (i, index) {
                return index <= 1;
              })) === null || _props$item$tag_categ32 === void 0 ? void 0 : _props$item$tag_categ32.join(", ")
            }), ((_props$item$tag_categ33 = props.item.tag_category) === null || _props$item$tag_categ33 === void 0 ? void 0 : _props$item$tag_categ33.length) > 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine
              },
              onPress: function onPress() {
                var _props$item$tag_categ34;

                alertModalFeatureRef.current.alert("Category", (_props$item$tag_categ34 = props.item.tag_category) === null || _props$item$tag_categ34 === void 0 ? void 0 : _props$item$tag_categ34.join(", "));
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: styles.boldText,
                children: "+" + (((_props$item$tag_categ35 = props.item.tag_category) === null || _props$item$tag_categ35 === void 0 ? void 0 : _props$item$tag_categ35.length) - 2)
              })
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
            style: [styles.rowContainer],
            onPress: function onPress() {
              alertModalCategoryRef.current.alert("Category", props.item.tag_category);
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagEventType */ .rU.iconTagEventType,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: props.item.tag_category
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconCalendarWhite */ .rU.iconCalendarWhite,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: ["Built in ", props.item.founding, " ", props.item.founding_unit]
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            onPress: function onPress() {
              alertModalCategoryRef.current.alert("Category", props.item.tag_category);
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagArea */ .rU.iconTagArea,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: props.item.tag_area
            })]
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagEventType */ .rU.iconTagEventType,
              style: [styles.locationPin]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: props.item.tag_category
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
            style: styles.bio,
            children: bio === null || bio === void 0 ? void 0 : bio.substring(0, 30)
          }), category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_12___default()), {
            style: [styles.rowContainer],
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
              style: [styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: [(_props$item22 = props.item) !== null && _props$item22 !== void 0 && _props$item22.tag_price ? "From ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .formatCurrency */ .xG)((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .formatNumber */ .uf)((_props$item23 = props.item) === null || _props$item23 === void 0 ? void 0 : _props$item23.tag_price))) : "", (_props$item24 = props.item) !== null && _props$item24 !== void 0 && _props$item24.tag_price ? " | " : "", "Min ".concat((0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .formatNumber */ .uf)((_props$item25 = props.item) === null || _props$item25 === void 0 ? void 0 : _props$item25.tag_size), " sqft")]
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
            children: category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL ? null : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_14___default()), {
              style: [styles.rowContainer],
              disabled: !hasNationality,
              onPress: function onPress() {
                if (hasNationality) alertModalLocationRef.current.alert("Location", category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY ? "".concat(nationality) : "".concat(city) // `${city}, ${nationality}`
                );
              },
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
                width: 20,
                height: 20,
                layout: "fixed",
                source: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconLocationPin */ .rU.iconLocationPin,
                style: styles.locationPin
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_13___default()), {
                style: [styles.text, {
                  marginLeft: 5
                }, isMobileVersion ? {
                  fontSize: 12,
                  lineHeight: 20
                } : {}],
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("address", {
                  style: {
                    fontStyle: "normal"
                  },
                  children: category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY ? "".concat(nationality) : "".concat(city)
                })
              })]
            })
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_molecules__WEBPACK_IMPORTED_MODULE_4__/* .AlertModal */ .VF, {
        icon: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagMusic */ .rU.iconTagMusic,
        ref: alertModalGenreRef,
        isMobileVersion: isMobileVersion,
        isSmall: true
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_molecules__WEBPACK_IMPORTED_MODULE_4__/* .AlertModal */ .VF, {
        icon: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagFeature */ .rU.iconTagFeature,
        ref: alertModalFeatureRef,
        isMobileVersion: isMobileVersion,
        isSmall: true
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_molecules__WEBPACK_IMPORTED_MODULE_4__/* .AlertModal */ .VF, {
        icon: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconTagEventType */ .rU.iconTagEventType,
        ref: alertModalCategoryRef,
        isMobileVersion: isMobileVersion,
        isSmall: true
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_molecules__WEBPACK_IMPORTED_MODULE_4__/* .AlertModal */ .VF, {
        icon: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconLocationPin */ .rU.iconLocationPin,
        ref: alertModalLocationRef,
        isMobileVersion: isMobileVersion,
        isSmall: true
      })]
    })
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_15___default().create({
  container: {
    alignSelf: "stretch",
    backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getClass */ .ll)("background"),
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25
  },
  userInfoContainer: {
    alignSelf: "stretch",
    flexDirection: "row",
    marginHorizontal: 16,
    marginTop: 15
  },
  nickname: {
    fontSize: 28,
    lineHeight: 32,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryBold */ .F3.primaryBold,
    color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getClass */ .ll)("text-white"),
    textAlign: "center"
  },
  durationContainer: {
    marginTop: 16,
    marginHorizontal: 16,
    marginBottom: 15
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  },
  locationPin: {
    width: 12,
    height: 12,
    marginRight: 4
  },
  text: {
    color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getClass */ .ll)("text-white"),
    fontSize: 16,
    lineHeight: 20,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryRegular */ .F3.primaryRegular
  },
  boldText: {
    color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getClass */ .ll)("text-white"),
    fontSize: 14,
    lineHeight: 17,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryBold */ .F3.primaryBold
  },
  locationText: {},
  tagContainer: {
    height: 20,
    paddingHorizontal: 6,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    backgroundColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.grayBackground */ .wL.grayBackground
  },
  tagText: {
    fontSize: 16,
    lineHeight: 18,
    color: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.whiteText */ .wL.whiteText
  },
  eventButtonContainer: {
    borderRadius: 12,
    height: 24,
    borderWidth: 1,
    borderColor: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.spliterLine */ .wL.spliterLine,
    alignItems: "center",
    justifyContent: "center",
    width: 104,
    flexDirection: "row"
  },
  eventButtonText: {
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryBold */ .F3.primaryBold,
    fontSize: 16,
    lineHeight: 18,
    color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getClass */ .ll)("text-white")
  },
  eventIcon: {
    width: 11,
    height: 11,
    marginRight: 4
  },
  badgeIcon: {
    marginLeft: 8,
    width: 10,
    height: 10
  },
  nameContainer: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center"
  },
  username: {
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryRegular */ .F3.primaryRegular,
    fontSize: 16,
    lineHeight: 18,
    color: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.placeholder */ .wL.placeholder
  },
  icon: {
    width: 19,
    height: 19
  },
  bio: {
    marginLeft: 16,
    marginTop: 10,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryRegular */ .F3.primaryRegular,
    fontSize: 16,
    lineHeight: 20,
    color: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.grayText2 */ .wL.grayText2,
    textAlign: "center",
    position: "absolute",
    width: "100%",
    zIndex: 0
  },
  bioMobile: {
    marginLeft: 16,
    marginTop: 10,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.primaryRegular */ .F3.primaryRegular,
    fontSize: 12,
    lineHeight: 20,
    color: _config__WEBPACK_IMPORTED_MODULE_2__/* .Colors.grayText2 */ .wL.grayText2
  }
});
/* harmony default export */ __webpack_exports__["default"] = (VenueInfoView);

/***/ })

}]);